import { createAction, props } from '@ngrx/store';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';
import { AssignUserPermissionRequest } from '../../../admin/interfaces/user-accout.interface';

export enum CustomerActionTypes {
    LoadCustomerContacts = '[Customer] Load Contacts',
    LoadCustomerContactsFinished = '[Customer] Load Contacts Finished',
    LoadCustomerContactsFailed = '[Customer] Load Contacts Failed',
    CleanCustomerContacts = '[Customer] Clean Customer Contacts',
    AssignOrRevokePermission = '[Customer] assign or revoke permissison',
    AssignOrRevokePermissionFinished = '[Customer] assign or revoke permissison finished',
    SetContactActiveStatus = '[Customer] set contact active status',
    LoadLiveLink = '[Customer] Load LiveLink',
    LoadLiveLinkFinished = '[Customer] Load LiveLink Finished'
}

export const loadCustomerContacts = createAction(CustomerActionTypes.LoadCustomerContacts, props<{ customerId: string }>());

export const loadCustomerContactsFinished = createAction(CustomerActionTypes.LoadCustomerContactsFinished, props<{ contacts: ContactResponse[] }>());

export const loadCustomerContactsFailed = createAction(CustomerActionTypes.LoadCustomerContactsFailed);

export const cleanAccountContact = createAction(CustomerActionTypes.CleanCustomerContacts);

export const assignOrRevokePermission = createAction(CustomerActionTypes.AssignOrRevokePermission, props<{ data: AssignUserPermissionRequest }>());

export const setContactActiveStatus = createAction(CustomerActionTypes.SetContactActiveStatus, props<{ customerId: string; contactId: string; isActive: boolean }>());

export const loadLiveLink = createAction(CustomerActionTypes.LoadLiveLink, props<{ customerId: string }>());

export const loadLiveLinkFinished = createAction(CustomerActionTypes.LoadLiveLinkFinished, props<{ livelinkUrl: string | undefined; livelinkExpiry: string | undefined }>());
